import { Enums } from '../common/enums'

import { IJsonSerializable } from './interfaces'

import { OpDescr } from '../core/op-descr'

import { OpExportPluginParam } from './op-export-plugin-param'
import { OpExportPluginColumn } from './op-export-plugin-column'

export class OpExportPlugin implements IJsonSerializable {

    // Members

    public columns: OpExportPluginColumn[]
    public defaultFileName: string
    public description: OpDescr
    public fileExtension: string[]
    public name: string
    public params: OpExportPluginParam[]
    public type: Enums.ReferenceType
    public workType: Enums.WorkType

    // Members End


    // Ctor

    constructor(opObj: any = null) {
        this.fromJSON(opObj)
    }

    // Ctor End


    public toString(): string {
        if (this.description != null) {
            return this.description.toString()
        }
      
        return this.name
    }


    // IJsonSerializable Implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj != null) {
            this.defaultFileName = opObj.DefaultFileName
            this.description = opObj.Description != null ? new OpDescr(opObj.Description) : null
            this.fileExtension = opObj.FileExtension
            this.name = opObj.Name
            this.type = opObj.Type ? opObj.Type : null
            this.workType = opObj.WorkType

            this.columns = opObj.Columns != null ? opObj.Columns.map((columnObj: any) => new OpExportPluginColumn(columnObj)) : null
            this.params = opObj.Params != null ? opObj.Params.map((paramObj: any) => new OpExportPluginParam(paramObj)) : null
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            DefaultFileName : this.defaultFileName,
            Description: this.description != null ? this.description.toJSON() : null,
            FileExtension: this.fileExtension,
            Name: this.name,
            Type: this.type,
            WorkType: this.workType,

            Columns: this.columns != null ? this.columns.map((column: OpExportPluginColumn) => column.toJSON()) : null,
            Params: this.params != null ? this.params.map((param: OpExportPluginParam) => param.toJSON()) : null
        }
    }

    // IJsonSerializable Implementation End
}